const backendUrl = process.env.REACT_APP_BACKEND_URL?.trim();
if (!backendUrl) {
  throw new Error(
    "REACT_APP_BACKEND_URL missing. Frontend/.env mein ek line uncomment karo."
  );
}

const base = backendUrl.replace(/\/$/, "");

export const API_BASE_URL = base;
export const BACKEND_PATH = `${base}/api/`;
export const MEDIA_URL = `${base}/media/`;

export const base_path = "";
export const img_path = "/";
